import { X } from "react-feather"

export default function Modal({ open, onClose, children }) {
  return (
    // backdrop
    <div
      onClick={onClose}
      className={`
        fixed inset-0 flex justify-center items-center transition-colors z-20
        ${open ? "visible bg-black/20" : "invisible"}
      `}
    >
      {/* modal */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`
          bg-white rounded-xl shadow p-6 transition-all
          ${open ? "scale-100 opacity-100" : "scale-125 opacity-0"}
        `}
      >
        <button
          onClick={onClose}
          className="absolute top-0.5 right-2 p-1 rounded-lg text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-600 border-0"
        >
          <X />
        </button>
        {children}
      </div>
    </div>
  )
}